export default __webpack_public_path__ + "static/media/NC_1400x282.0a517470.png";